module.exports = class ValidaTexto {

    static valida(texto,nomeCampo,podeEstarEmBranco,tamanhoMaximo) {
        if (!texto) {
            if (podeEstarEmBranco) {
                return '';
            }
            throw obterMsgErro(`O campo '${nomeCampo}' deve estar preenchido!`);
        }
        
        if (texto.length > tamanhoMaximo) {
            throw obterMsgErro(
                `O tamanho do campo '${nomeCampo}' não pode exceder o limite máximo de ${tamanhoMaximo} caracteres!`
            );
        }

        return retiraJavascriptMalicioso(texto);
    }
}

const obterMsgErro = rotulo => {
    return ({ status:400, tipo:'problema', texto:rotulo })
}

const retiraJavascriptMalicioso = _texto => {
    let texto = _texto.trim()
    while (texto.includes('<') || texto.includes('&lt;') || texto.includes('&#60;')) {
        texto = texto.replace('<','menor').replace('&lt;','menor').replace('&#60;','menor')
    }
    return texto
}